import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'link',
  props: ["class", "to"],
  setup: function setup(__props) {
    var _router$currentRoute;
    var props = __props;
    var router = useRouter();
    var lang = router === null || router === void 0 || (_router$currentRoute = router.currentRoute) === null || _router$currentRoute === void 0 || (_router$currentRoute = _router$currentRoute.value.params) === null || _router$currentRoute === void 0 ? void 0 : _router$currentRoute.lang;
    var to = function to() {
      var res = '';
      if (lang) {
        res = "/".concat(lang, "/").concat(props.to);
      } else {
        res = "".concat(props.to);
      }
      return to;
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createBlock(_component_router_link, {
        "class": _normalizeClass(props["class"]),
        to: to
      }, {
        "default": _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["class"]);
    };
  }
});